import {
  createComplementaryItem,
  deleteComplementaryItem,
  updateComplementaryItem,
} from '@store/balance/ComplementaryItemReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const ComplementaryItemForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.complementaryItem)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createComplementaryItem(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateComplementaryItem(values)).then(() => {
              return true
            }),
          delete: async (values) => {
            return dispatch(deleteComplementaryItem(values)).then(() => {
              return true
            })
          },
        }}
      />
    )
  }
)

ComplementaryItemForm.displayName = 'ComplementaryItemForm'

export default ComplementaryItemForm
